import { Messages } from "./messages";
import { HttpErrorResponse } from "@angular/common/http";
import { TimeoutError } from "rxjs";

export function handleMsgError(error: any, loopError: boolean = false) {
  let msg: string = Messages.SERVER_ERROR;
  console.log('error', error);

  try {
    if (error instanceof HttpErrorResponse || error.hasOwnProperty('error') || error.hasOwnProperty('message')) {
      if (error.hasOwnProperty('status') || (error.error && error.error.hasOwnProperty('customError'))) {
        if (error.status === 0) {
          msg = error.message ? error.message : 'Http failure';
        }
        else if (error.status >= 500) {
          if (error.error && error.error.error && error.error.error.message) {
            msg = error.error.error.message;
          } else if (error.error && error.error.message) {
            msg = error.error.message;
          }
        }
        else {
          if (error.error) {
            if (error.error.message) {
              msg = error.error.message;
              if (loopError && error.error.errors) {
                if (error.error.errors.length > 0) {
                  let tempTeks = '';
                  for (const item of error.error.errors) {
                    tempTeks += `- ${item.messages}<br>`;
                  }
                  msg = tempTeks;
                }
              }
            }
            else {
              if (error.message) {
                msg = error.message;
              }
              else {
                msg = error.status + (error.error) ? ` ${error.error}` : ' Network Failure';
              }
            }
          }
          else {
            if (error.message) {
              msg = error.message;
            }
            else {
              msg = error.status + ' error network without messagge';
            }
          }
        }
      }
      else {
        if (error.message) {
          msg = error.message;
        }
        else {
          msg = error;
        }
      }
    }
    else if (error instanceof TimeoutError) {
      msg = error.message ? error.message : 'Timeout Error';
    }
    else if (typeof error === 'string') {
      msg = error;
    }
  } catch (error) {
    msg = Messages.SERVER_ERROR;
  }
  return msg;
}

export function handleErrorList(error) {
  // (err && err.status && err.status >= 500) ? [] : err.error.errors
  let result = [];

  if (error) {
    if (error.status) {
      if (error.status < 500) {
        if (error.error) {
          if (error.error.errors) {
            result = error.error.errors;
          }
        }
      }
    }
  }

  return result;
} 



// WEBPACK FOOTER //
// ./src/helpers/handle-error-message.helper.ts